import makeService from './api';

export default makeService('printing_surfaces');
